const updates = [
  { time: '刚刚', title: '某选秀节目冠军被曝学历造假，节目组回应称正在核实', tag: '最新' },
  { time: '15分钟前', title: '网红情侣官宣分手，双方社交平台已互相取关', tag: '最新' },
  { time: '32分钟前', title: '知名导演新片拍摄现场发生意外，一名工作人员受伤送医', tag: '' },
  { time: '1小时前', title: '女团成员被拍到与神秘男子同游日本，经纪公司暂未回应', tag: '热门' },
  { time: '2小时前', title: '综艺节目最新一期收视率创历史新低，网友吐槽内容注水', tag: '' },
  { time: '3小时前', title: '某品牌官宣更换代言人，原代言人粉丝掀起抵制潮', tag: '热议' },
  { time: '4小时前', title: '影视剧剧组被曝拖欠群演工资，劳动监察部门介入调查', tag: '' },
  { time: '5小时前', title: '直播平台头部主播涉嫌虚假宣传，消费者协会发函约谈', tag: '关注' },
  { time: '6小时前', title: '娱乐公司CEO被曝财务造假，公司股价开盘暴跌', tag: '' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">最新快讯</h2>
        <p className="text-sm text-foreground-500 mb-8">网红吃瓜吃料网每日爆料实时更新，最新八卦一手掌握</p>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200/70"></div>
          <div className="flex flex-col gap-0">
            {updates.map((item, idx) => (
              <div key={idx} className="flex items-start gap-4 py-3 relative">
                <span className="relative z-10 flex-shrink-0 w-[38px] h-[38px] flex items-center justify-center rounded-full bg-background-100 border-2 border-background-200/70">
                  <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                </span>
                <div className="flex-1 min-w-0 pt-2">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs text-foreground-400 font-medium">{item.time}</span>
                    {item.tag && (
                      <span className={`px-1.5 py-0.5 rounded text-xs font-medium ${
                        item.tag === '最新' ? 'bg-primary-100 text-primary-700' :
                        item.tag === '热门' ? 'bg-accent-100 text-accent-700' :
                        'bg-secondary-100 text-secondary-700'
                      }`}>
                        {item.tag}
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}